<script lang="ts" setup>
const isShowModal = defineModel<boolean>({ default: false });

defineProps<{
  deliveries: {
    title: string;
    time: string;
    price: number | null;
  }[];
  isLoading: boolean;
}>();
</script>

<template>
  <BaseModal
    v-model="isShowModal"
    @close="isShowModal = false"
  >
    <div class="product-page-available-delivery-terms-modal">
      <LocationSelectBlock label="Ваш город" />

      <p class="text-xs text-hell-black-60">
        Укажите ваш город и мы сможем предоставить наиболее точную информацию о доступных условиях доставки
      </p>

      <div class="flex flex-col gap-2 text-sm">
        <p class="text-sm font-bold">Доставка этого товара:</p>

        <div
          v-if="isLoading"
          class="flex items-center justify-center p-4"
        >
          <SvgoSpinner
            :font-controlled="false"
            class="animate-spin size-10"
            title="Идет загрузка..."
          />
        </div>

        <template v-else-if="deliveries.length">
          <OptionSelectCardBlock
            v-for="delivery in deliveries"
            :key="delivery.title"
            no-pointer
          >
            <div>
              <p class="text-sm font-bold mb-1">{{ delivery.title }}</p>

              <p
                v-if="delivery.time"
                class="mb-3"
              >
                Дата доставки – <strong v-html="delivery.time" />
              </p>

              <p
                v-if="delivery.price === 0"
                class="text-hell-green font-bold"
              >
                Бесплатно
              </p>

              <p v-else-if="delivery.price !== null">
                от <strong>{{ delivery.price }} ₽</strong>
              </p>
            </div>
          </OptionSelectCardBlock>
        </template>

        <span
          v-else
          class="text-hell-red"
        >
          Не удалось получить уточненную информацию.<br />Попробуйте, пожалуйста, позже.
        </span>
      </div>
    </div>
  </BaseModal>
</template>

<style lang="scss">
.product-page-available-delivery-terms-modal {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 480px;
  padding-bottom: 12px;

  @include screen-sm {
    & .base-modal__content {
      height: 549px;
    }
  }

  &__type-btn {
    flex-grow: 1;
    min-width: 50%;
    max-width: 100%;
    height: 36px;
    border: 3px solid $hell-black-5;
    background-color: $hell-black-5;
    color: $hell-black-80;
    transition: all 0.4s;

    &--selected {
      background-color: $white;
      color: $hell-black;
    }

    &:hover {
      color: $hell-black-40;
    }
  }

  &__points {
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;
    height: 420px;

    @include screen-sm {
      grid-template-columns: 1fr 1fr;
    }
  }

  &__shops-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow-y: auto;
  }

  &__shops-list-item {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 12px;
    border: 1px solid transparent;
    border-radius: 12px;
    background-color: $hell-black-5;
    font-size: $text-sm;
    transition: all 0.3s;
  }
}
</style>
